import { useEffect, useRef } from "react";

/**
 * Custom hook that creates a ref and automatically updates it when the target value changes.
 * Useful for accessing the latest value in callbacks without recreating them.
 *
 * @param target - The value to keep in the ref
 * @returns A ref containing the latest value
 */
export function useRefWithEffect<T>(target: T) {
    const ref = useRef(target);

    useEffect(() => {
        ref.current = target;
    }, [target]);

    return ref;
}
